import { Component, inject, OnInit, DestroyRef } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MessageService } from './shared/services/message/message.service';
import { StoreService } from './shared/services/store/store.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StyleService } from './shared/services/style/style.service';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule, SpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  // Injected dependencies
  private readonly messageService = inject(MessageService);
  private readonly storeService = inject(StoreService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly styleService = inject(StyleService);

  // Loading signals (render the page as spinning)
  public isLoading = this.styleService.isLoading;

  constructor() {
    // Listen to host open messages and populate the store service
    toObservable(this.messageService.hostOpen).pipe(
      filter(msg => msg != undefined),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(msg => {
      if (msg != null) this.storeService.setSessionId(msg.sessionId);
    });
  }

  ngOnInit(): void {
    this.messageService.ready();
  }
}
